import { Choice } from '90.quickConnect.Models/models';

const isAnArrayOfChoice = (input: any): input is Choice[] =>
  Array.isArray(input) && input.every((item: any) => 'label' in item && 'value' in item);

export default isAnArrayOfChoice;
